import merge from "lodash.merge";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { store, persistor } from "./store/store";
// import { WebchatWidget } from "./components/WebchatWidget";
import { sessionDataHandler } from "./sessionDataHandler";
import { initConfig } from "./store/actions/initActions";
import { ConfigState } from "./store/definitions";
import { initLogger } from "./logger";
// import { ServerForm } from "./components/ServerForm";
import { WebChat } from "./components/customized/WebChat";

// 禁止的文件类型列表
const forbiddenExtensions = ["cif", "fastq", "bam", "vcf", "idat", "egt", "gtc"];

const defaultConfig: ConfigState = {
    // serverUrl: "http://192.168.124.14:3001/",
    serverUrl: "http://localhost:3001/",
    // serverUrl: "https://36ibyr879730.vicp.fun/3001/",
    theme: {
        isLight: true
    },
    fileAttachment: {
        enabled: true,
        maxFileSize: 10485760, // 10 MB
        acceptedExtensions: ["*"],
        forbiddenExtensions
    },
    transcript: {
        downloadEnabled: false,
        emailEnabled: false,
        emailSubject: (agentNames) => {
            let subject = "Transcript of your chat";
            if (agentNames.length > 0) {
                subject = subject.concat(` with ${agentNames[0]}`);
                agentNames.slice(1).forEach((name) => (subject = subject.concat(` and ${name}`)));
            }
            return subject;
        },
        emailContent: (customerName, transcript) => {
            return `<div><h1 style="text-align:center;">Chat Transcript</h1><p>Hello ${customerName},<br><br>Please see below your transcript, with any associated files attached, as requested.<br><br>${transcript}</p></div>`;
        }
    },
    // 浮窗/切走时页内声光震动；也可用 REACT_APP_BACKGROUND_ALERT_ENABLED=true 开启
    backgroundAlert: {
        enabled: process.env.REACT_APP_BACKGROUND_ALERT_ENABLED === "true",
        sound: true,
        vibrate: true,
        flash: true
    }
};

const initWebchat = async (config: ConfigState) => {
    const mergedConfig = merge({}, defaultConfig, config);
    sessionDataHandler.setEndpoint(mergedConfig.serverUrl);
    store.dispatch(initConfig(mergedConfig));
    initLogger();
    const rootElement = document.getElementById("twilio-webchat-widget-root");

    // render(<ServerForm />, document.getElementById("serverForm"));
    render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <WebChat />
            </PersistGate>
        </Provider>,
        rootElement
    );

    if (window.Cypress) {
        window.store = store;
    }
};

declare global {
    interface Window {
        Twilio: {
            initWebchat: (config: ConfigState) => void;
        };
        Cypress: Cypress.Cypress;
        store: typeof store;
    }
}

// Expose `initWebchat` function to window object
Object.assign(window, {
    Twilio: {
        initWebchat
    }
});
